import axiosSetup from "../../utils/axiosSetup";
import {
  AvailableTransferMaterial,
  CreateMaterialTransferPayload,
  MaterialTransferPage,
} from "../../models/materialStockTransfer.model";

interface ApiPagination {
  totalCount?: number;
  page?: number;
  totalPages?: number;
}

interface ApiEnvelope<T> {
  data: T;
  message?: string;
  pagination?: ApiPagination;
}

export interface AvailableMaterialsQuery {
  page: number;
  limit: number;
  search?: string;
  warehouseId?: string;
}

export const fetchAvailableTransferMaterialsApi = async (
  query: AvailableMaterialsQuery,
) => {
  const response = await axiosSetup.get<
    ApiEnvelope<AvailableTransferMaterial[]>
  >("/material-stock-transfer/available-materials", { params: query });
  return {
    materials: response.data.data,
    pagination: response.data.pagination,
  };
};

const fetchPendingTransfers = async (
  direction: "incoming" | "outgoing",
  page: number,
  limit: number,
): Promise<MaterialTransferPage> => {
  const response = await axiosSetup.get<
    ApiEnvelope<{
      transfers: MaterialTransferPage["transfers"];
      totalCount?: number;
      total?: number;
      page?: number;
      totalPages?: number;
    }>
  >(`/material-stock-transfer/pending-${direction}?page=${page}&limit=${limit}`);
  const data = response.data.data;
  const pagination = response.data.pagination;

  return {
    transfers: data.transfers,
    total:
      data.total ??
      data.totalCount ??
      pagination?.totalCount ??
      data.transfers.length,
    page: data.page ?? pagination?.page ?? page,
    totalPages: data.totalPages ?? pagination?.totalPages ?? 1,
  };
};

export const fetchPendingIncomingMaterialTransfersApi = (
  page = 1,
  limit = 10,
) => fetchPendingTransfers("incoming", page, limit);

export const fetchPendingOutgoingMaterialTransfersApi = (
  page = 1,
  limit = 10,
) => fetchPendingTransfers("outgoing", page, limit);

export const createMaterialStockTransferApi = async (
  payload: CreateMaterialTransferPayload,
) => {
  const response = await axiosSetup.post<ApiEnvelope<unknown>>(
    "/material-stock-transfer/create",
    payload,
  );
  return response.data.data;
};

export const acceptMaterialStockTransfersApi = async (
  transfers: Array<{ transferId: string; remark?: string }>,
) => {
  const response = await axiosSetup.post<ApiEnvelope<unknown>>(
    "/material-stock-transfer/accept",
    { transfers },
  );
  return response.data.data;
};

export const cancelMaterialStockTransfersApi = async (
  transfers: Array<{ transferId: string; remark?: string }>,
) => {
  const response = await axiosSetup.post<ApiEnvelope<unknown>>(
    "/material-stock-transfer/cancel",
    { transfers },
  );
  return response.data.data;
};
